import { c as _c } from "react/compiler-runtime";
import { LayoutContainer } from '@petsmart-ui/sparky';
import type { LinkTilesProps } from '../types';
import Tile4Links from './Tile4Links';
import Tile4LinksMobile from './Tile4LinksMobile';
import './Tile4Links.scss';
export default function Tile4Wrapper(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <LayoutContainer className="tile4-container"><Tile4Links {...props} /><Tile4LinksMobile {...props} /></LayoutContainer>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}